import {
  useIsMinDesktopSize,
  useIsMinDesktopSizeL,
  useIsMinDesktopSizeM,
  useIsMinPhoneSize,
  useIsMinTabletSize,
} from "~/common/hooks/useMediaQuery";

export const useNumericScreenSize = () => {
  const sizes = [
    +useIsMinPhoneSize(),
    +useIsMinTabletSize(),
    +useIsMinDesktopSize(),
    +useIsMinDesktopSizeM(),
    +useIsMinDesktopSizeL(),
  ];
  return sizes.reduce((a, b) => a + b, 0) as AllScreenSizes;
};

export const SIZE_BELOW_PHONE = 0;
useNumericScreenSize.belowPhone = 0 as const;
export const SIZE_PHONE = 1;
useNumericScreenSize.phone = 1 as const;
export const SIZE_TABLET = 2;
useNumericScreenSize.tablet = 2 as const;
export const SIZE_DESKTOP_S = 3;
useNumericScreenSize.desktopS = 3 as const;
export const SIZE_DESKTOP_M = 4;
useNumericScreenSize.desktopM = 4 as const;
export const SIZE_DESKTOP_L = 5;
useNumericScreenSize.desktopL = 5 as const;

export type SupportedScreenSizes =
  | typeof SIZE_PHONE
  | typeof SIZE_TABLET
  | typeof SIZE_DESKTOP_S
  | typeof SIZE_DESKTOP_M
  | typeof SIZE_DESKTOP_L;
export type AllScreenSizes = typeof SIZE_BELOW_PHONE | SupportedScreenSizes;
